import { httpsCallable } from "firebase/functions";
import { functions } from '@/firebase/config.js';
import { collection, getDocs, doc, getDoc, query, where, orderBy, deleteDoc, limit, startAfter, updateDoc, onSnapshot, addDoc, getCountFromServer } from "firebase/firestore";
import { db } from '@/firebase/config.js';
import { reviewersColName } from '@/firebase/vars';

// temp file
// import { updateDoc } from "firebase/firestore";
// export const updateItemsCount = async() => {
//     const querySnapshot = await getDocs(collection(db, reviewersColName, 'caap', "subtopics"));
//     let allSubtopics = [];
//     // loop to all subtopics
//     querySnapshot.forEach(async(subtopic) => {
//         let items = 0;
//         allSubtopics.push({ id: subtopic.id, data: subtopic.data() })

//         // check if subtopic id exist at questionnaires collections
//         const docRef = doc(db, "questionnaires", subtopic.id);
//         const docSnap = await getDoc(docRef);
//         if (docSnap.exists()) {
//             // get subtopics question count
//             items = docSnap.data().questions.length;
//             console.log(`id:${subtopic.id} ===> items: ${items} `)
//         }

//         // update subtopic items
//         const subtopicRef = doc(db, reviewersColName, 'caap', "subtopics", subtopic.id);
//         await updateDoc(subtopicRef, {
//             items: items
//         });
//     });
// }

export const getSubtopics = async(reviewer) => {
    const querySnapshot = await getDocs(collection(db, reviewersColName, reviewer, "subtopics"));
    let allSubtopics = [];
    querySnapshot.forEach(doc => {
        allSubtopics.push({ id: doc.id, data: doc.data() })
    });
    return { isError: false, subtopics: allSubtopics }
}

export const getSubjects = async(reviewer) => {
    const querySnapshot = await getDocs(collection(db, reviewersColName, reviewer, "subjects"));
    let allSubjects = [];
    querySnapshot.forEach(doc => {
        allSubjects.push({ id: doc.id, data: doc.data() })
    });
    return { isError: false, subjects: allSubjects }
}

export const getSubject = async(reviewer, subjectId) => {
    const docSnap = await getDoc(doc(db, reviewersColName, reviewer, "subjects", subjectId));
    if (docSnap.exists()) {
        return { isError: false, data: docSnap.data() }
    } else {
        return { isError: true, data: null }
    }
}

export const createSubtopic = async(revId, form) => {

    // Add an additional initial validation here to ensure no duplicate subtopic IDs.
    // This will prevent overriding the questionnaire data bank.
    let subjectIds = [];
    let querySnapshot = await getDocs(collection(db, "reviewers"));
    querySnapshot.forEach((doc) => {
        subjectIds.push(doc.id)
    });

    const promises = subjectIds.map(async docId => {
        const subtopicCollectionRef = collection(db, "reviewers", docId, "subtopics");
        return getDocs(subtopicCollectionRef).then(querySnapshot => {
            return querySnapshot.docs.map(doc => doc.id);
        });
    });

    // Wait for all promises to resolve
    const results = await Promise.all(promises);
    // Flatten the results array
    const allSubtopicIds = results.flat();

    if (allSubtopicIds.includes(form.id)) {
        return { data: { isError: true, error: ['Subtopic ID already exist.'] } };
    }

    const createSubtopic = httpsCallable(functions, 'createSubtopic');
    return await createSubtopic({ revId, form })
        .then((result) => {
            return result;
        })
        .catch((err) => {
            return err;
        });
}

export const updateSubtopic = async(revId, form) => {
    const updateSubtopic = httpsCallable(functions, 'updateSubtopic');
    return await updateSubtopic({ revId, form })
        .then((result) => {
            return result;
        })
        .catch((err) => {
            return err;
        });
}

export const deleteSubtopic = async(revId, subtopicId) => {
    const deleteSubtopic = httpsCallable(functions, 'deleteSubtopic');
    return await deleteSubtopic({ revId, subtopicId })
        .then((result) => {
            return result;
        })
        .catch((err) => {
            return err;
        });
}

export const createSubject = async(revId, form) => {
    const createSubject = httpsCallable(functions, 'createSubject');
    return await createSubject({ revId, form })
        .then((result) => {
            return result;
        })
        .catch((err) => {
            return err;
        });
}

export const updateSubject = async(revId, form) => {
    const updateSubject = httpsCallable(functions, 'updateSubject');
    return await updateSubject({ revId, form })
        .then((result) => {
            return result;
        })
        .catch((err) => {
            return err;
        });
}

export const deleteSubject = async(revId, subjectId) => {
    const deleteSubject = httpsCallable(functions, 'deleteSubject');
    return await deleteSubject({ revId, subjectId })
        .then((result) => {
            return result;
        })
        .catch((err) => {
            return err;
        });
}

export const getCourses = async(reviewer) => {
    const docSnap = await getDoc(doc(db, reviewersColName, reviewer));
    if (docSnap.exists()) {
        return { isError: false, data: docSnap.data().courses }
    } else {
        return { isError: true, data: null }
    }
}

export const createCourse = async(revId, form) => {
    const createCourse = httpsCallable(functions, 'createCourse');
    return await createCourse({ revId, form })
        .then((result) => {
            return result;
        })
        .catch((err) => {
            return err;
        });
}

export const updateCourse = async(revId, form) => {
    const updateCourse = httpsCallable(functions, 'updateCourse');
    return await updateCourse({ revId, form })
        .then((result) => {
            return result;
        })
        .catch((err) => {
            return err;
        });
}

export const deleteCourse = async(revId, id) => {
    const deleteCourse = httpsCallable(functions, 'deleteCourse');
    return await deleteCourse({ revId, id })
        .then((result) => {
            return result;
        })
        .catch((err) => {
            return err;
        });
}

export const getCourse = async(reviewer, courseId) => {
    const docSnap = await getDoc(doc(db, reviewersColName, reviewer));
    if (docSnap.exists()) {
        let courses = docSnap.data().courses;
        return { isError: false, data: courses.find(c => c.id == courseId) }
    } else {
        return { isError: true, data: null }
    }
}

export const updateCourses = async(revId, courses) => {
    const updateCourses = httpsCallable(functions, 'updateCourses');
    return await updateCourses({ revId, courses })
        .then((result) => {
            return result;
        })
        .catch((err) => {
            return err;
        });
}


export const createTag = async(revId, form) => {
    const createTag = httpsCallable(functions, 'createTag');
    return await createTag({ revId, form })
        .then((result) => {
            return result;
        })
        .catch((err) => {
            return err;
        });
}

export const getTags = async(reviewer) => {

    const q = query(collection(db, 'tags'), where("reviewerId", "==", reviewer), orderBy('name', 'asc'));

    const querySnapshot = await getDocs(q);
    let allTags = [];
    querySnapshot.forEach(doc => {
        allTags.push({ id: doc.id, data: doc.data() })
    });
    return { isError: false, tags: allTags }
}

export const updateTag = async(revId, tagId, form) => {
    const updateTag = httpsCallable(functions, 'updateTag');
    return await updateTag({ revId, tagId, form })
        .then((result) => {
            return result;
        })
        .catch((err) => {
            return err;
        });
}

export const deleteTag = async(revId, tagId) => {
    const deleteTag = httpsCallable(functions, 'deleteTag');
    return await deleteTag({ revId, tagId })
        .then((result) => {
            return result;
        })
        .catch((err) => {
            return err;
        });
}

export const getTagsQuestions = async(revId) => {

    const q = query(collection(db, 'tags_questions'), where("revId", "==", revId));

    const querySnapshot = await getDocs(q);
    let allTagsQuestions = [];
    querySnapshot.forEach(doc => {
        allTagsQuestions.push({ id: doc.id, data: doc.data() })
    });
    return { isError: false, tagsQuestions: allTagsQuestions }

}

export const getSubtopicQuestions = async(subtopicId) => {

    const docSnap = await getDoc(doc(db, 'questionnaires', subtopicId));
    if (docSnap.exists()) {
        return docSnap.data().questions;
    } else {
        return null
    }

}

/**
 * Build shared constraints for explanations list/count queries.
 * @param {{ mode?: 'downvoted'|'all', subtopicId?: string|null, questionId?: string|null }} opts
 * @returns {{ constraints: import('firebase/firestore').QueryConstraint[], clientFilterDownvoted: boolean }}
 */
const buildExplanationsConstraints = ({ mode = 'downvoted', subtopicId = null, questionId = null } = {}) => {
    const qid = typeof questionId === 'string' ? questionId.trim() : ''
    const subId = typeof subtopicId === 'string' ? subtopicId.trim() : ''
    const downvotedOnly = mode === 'downvoted'

    // Exact questionId search overrides tab + subtopic filters
    if (qid) {
        return {
            constraints: [where('questionId', '==', qid)],
            clientFilterDownvoted: false,
        }
    }

    if (subId) {
        const prefix = `${subId}_`
        // Prefix range requires orderBy('questionId'). Downvoted is applied client-side
        // so we do not need a multi-inequality composite index for this combo.
        return {
            constraints: [
                where('questionId', '>=', prefix),
                where('questionId', '<', prefix + '\uf8ff'),
                orderBy('questionId'),
            ],
            clientFilterDownvoted: downvotedOnly,
        }
    }

    if (downvotedOnly) {
        return {
            constraints: [where('downvotes', '>', 0), orderBy('downvotes', 'desc')],
            clientFilterDownvoted: false,
        }
    }

    // All explanations, highest downvotes first (includes 0)
    return {
        constraints: [orderBy('downvotes', 'desc')],
        clientFilterDownvoted: false,
    }
}

/**
 * Paginated explanations for `/data/explanations`.
 * @param {object} options
 * @param {number} options.pageSize
 * @param {import('firebase/firestore').QueryDocumentSnapshot|null} [options.lastDoc]
 * @param {'downvoted'|'all'} [options.mode]
 * @param {string|null} [options.subtopicId]
 * @param {string|null} [options.questionId] exact `questionId` (`{subtopicId}_{questionNumber}`)
 */
export const fetchExplanations = async ({
    pageSize = 100,
    lastDoc = null,
    mode = 'downvoted',
    subtopicId = null,
    questionId = null,
} = {}) => {
    const explanationsRef = collection(db, 'explanations')
    const { constraints, clientFilterDownvoted } = buildExplanationsConstraints({ mode, subtopicId, questionId })

    const explanations = []
    let cursor = lastDoc
    let isLastPage = false

    // When Downvoted + subtopic, keep paging until we fill pageSize matches or hit end
    const maxPasses = clientFilterDownvoted ? 20 : 1
    for (let pass = 0; pass < maxPasses && explanations.length < pageSize && !isLastPage; pass++) {
        const qConstraints = [...constraints, limit(pageSize)]
        if (cursor) qConstraints.push(startAfter(cursor))

        const querySnapshot = await getDocs(query(explanationsRef, ...qConstraints))

        if (querySnapshot.empty) {
            isLastPage = true
            break
        }

        let filledEarly = false
        for (const docSnap of querySnapshot.docs) {
            if (clientFilterDownvoted && !(Number(docSnap.data().downvotes) > 0)) {
                cursor = docSnap
                continue
            }
            if (explanations.length >= pageSize) {
                // Matching doc remains after this page — do not advance cursor past last added
                filledEarly = true
                break
            }
            explanations.push({ id: docSnap.id, data: docSnap.data() })
            cursor = docSnap
        }

        isLastPage = !filledEarly && querySnapshot.size < pageSize
    }

    return {
        isError: false,
        explanations,
        lastDoc: cursor,
        isLastPage,
    }
}

/**
 * Total matching docs for the current filters (same semantics as fetchExplanations list modes).
 * For Downvoted + subtopic, returns the full subtopic prefix count (server cannot cheaply
 * combine downvotes inequality with questionId range); `approximate: true` in that case.
 */
export const countExplanations = async ({
    mode = 'downvoted',
    subtopicId = null,
    questionId = null,
} = {}) => {
    const explanationsRef = collection(db, 'explanations')
    const qid = typeof questionId === 'string' ? questionId.trim() : ''
    const subId = typeof subtopicId === 'string' ? subtopicId.trim() : ''
    const downvotedOnly = mode === 'downvoted'

    try {
        if (qid) {
            const snap = await getCountFromServer(query(explanationsRef, where('questionId', '==', qid)))
            return { isError: false, count: snap.data().count, approximate: false }
        }

        if (subId) {
            const prefix = `${subId}_`
            const snap = await getCountFromServer(query(
                explanationsRef,
                where('questionId', '>=', prefix),
                where('questionId', '<', prefix + '\uf8ff'),
            ))
            // Prefix count only; if Downvoted tab, mark approximate (includes zero-downvote docs)
            return {
                isError: false,
                count: snap.data().count,
                approximate: downvotedOnly,
            }
        }

        if (downvotedOnly) {
            const snap = await getCountFromServer(query(explanationsRef, where('downvotes', '>', 0)))
            return { isError: false, count: snap.data().count, approximate: false }
        }

        const snap = await getCountFromServer(explanationsRef)
        return { isError: false, count: snap.data().count, approximate: false }
    } catch (error) {
        console.error('Error counting explanations:', error.message)
        return { isError: true, count: null, approximate: false, error }
    }
}

export const deleteExplanation = async (explanationId) => {

    return await deleteDoc(doc(db, 'explanations', explanationId))
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.error('Error removing explanation:', error.message);
      return error;
    });

}

export const updateExplanation = async (form) => {

    await updateDoc(doc(db, 'explanations', form.id), form.data)
        .then(() => {
          console.log('Explanation updated successfully.');
        })
        .catch((error) => {
          console.error('Error updating explanation:', error.message);
        });

}

/**
 * November 16, 2025:
 * Reads the single document at `settings/new-subtopics` which contains an `ids` array
 * of subtopic IDs flagged as "new". This is a global flag, not reviewer-specific.
 */
export const getFlaggedNewSubtopics = async() => {
    const docSnap = await getDoc(doc(db, 'settings', 'new-subtopics'));
    if (docSnap.exists()) {
        const data = docSnap.data();
        const ids = Array.isArray(data.ids) ? data.ids : [];
        return { isError: false, ids };
    } else {
        return { isError: true, ids: [] };
    }
}

/**
 * November 16, 2025:
 * Subscribes to the `settings/new-subtopics` document and calls the `onChange` function
 * with the new subtopic IDs.
 */
export const subscribeFlaggedNewSubtopics = (onChange) => {
    const ref = doc(db, 'settings', 'new-subtopics');
    const unsubscribe = onSnapshot(ref, (docSnap) => {
        const ids = docSnap.exists() && Array.isArray(docSnap.data().ids) ? docSnap.data().ids : [];
        onChange({ isError: false, ids });
    }, (error) => {
        onChange({ isError: true, ids: [], error });
    });
    return unsubscribe;
}

/**
 * November 16, 2025:
 * Updates the `settings/new-subtopics` document with the new subtopic IDs.
 */
export const updateFlaggedNewSubtopics = async(ids) => {
    try {
        await updateDoc(doc(db, 'settings', 'new-subtopics'), { ids });
        return { isError: false };
    } catch (error) {
        console.error('Error updating flagged new subtopics:', error.message);
        return { isError: true, error };
    }
}

/**
 * Prefer one explanation doc when duplicates share the same questionId.
 * Prefer textHtml, then net votes, then stable doc id.
 */
const pickPreferredExplanationDoc = (docs) => {
    if (!docs || docs.length === 0) return null
    return [...docs].sort((a, b) => {
        const aHtml = (a.data().textHtml || '').trim() ? 1 : 0
        const bHtml = (b.data().textHtml || '').trim() ? 1 : 0
        if (aHtml !== bHtml) return bHtml - aHtml

        const aScore = (Number(a.data().upvotes) || 0) - (Number(a.data().downvotes) || 0)
        const bScore = (Number(b.data().upvotes) || 0) - (Number(b.data().downvotes) || 0)
        if (aScore !== bScore) return bScore - aScore

        const aUp = Number(a.data().upvotes) || 0
        const bUp = Number(b.data().upvotes) || 0
        if (aUp !== bUp) return bUp - aUp

        return a.id < b.id ? -1 : 1
    })[0]
}

/**
 * Delete sibling explanation docs with the same questionId, keeping `keepId`.
 */
export const deleteSiblingExplanations = async (questionId, keepId) => {
    if (!questionId || !keepId) return 0

    const q = query(collection(db, 'explanations'), where('questionId', '==', questionId))
    const snapshot = await getDocs(q)
    let deleted = 0

    for (const explanationDoc of snapshot.docs) {
        if (explanationDoc.id === keepId) continue
        await deleteDoc(doc(db, 'explanations', explanationDoc.id))
        deleted += 1
    }

    return deleted
}

/**
 * Upsert an explanation by logical questionId (field), without using questionId as doc id.
 *
 * Client Firestore cannot run collection queries inside transactions, so uniqueness is enforced by:
 * 1) query by questionId
 * 2) update preferred existing doc OR addDoc once
 * 3) re-query and delete siblings if a race created extras
 *
 * Future rewrite should use canonical doc id `explanations/{questionId}` + transaction.get(docRef).
 *
 * @param {object} payload - must include questionId; typically text / textHtml / votes
 * @param {{ preserveVotes?: boolean }} [options]
 * @returns {Promise<{ id: string, created: boolean, cleaned: number }>}
 */
export const upsertExplanationByQuestionId = async (payload, options = {}) => {
    const { preserveVotes = true } = options
    const questionId = payload?.questionId

    if (!questionId) {
        throw new Error('upsertExplanationByQuestionId requires payload.questionId')
    }

    const q = query(collection(db, 'explanations'), where('questionId', '==', questionId))
    const existing = await getDocs(q)

    if (!existing.empty) {
        const preferred = pickPreferredExplanationDoc(existing.docs)
        const current = preferred.data() || {}
        const next = {
            ...payload,
            questionId
        }

        if (preserveVotes) {
            next.upvotes = current.upvotes != null ? current.upvotes : (payload.upvotes || 0)
            next.downvotes = current.downvotes != null ? current.downvotes : (payload.downvotes || 0)
        }

        await updateDoc(doc(db, 'explanations', preferred.id), next)
        const cleaned = await deleteSiblingExplanations(questionId, preferred.id)
        return { id: preferred.id, created: false, cleaned }
    }

    const createdRef = await addDoc(collection(db, 'explanations'), {
        upvotes: 0,
        downvotes: 0,
        ...payload,
        questionId
    })

    const afterCreate = await getDocs(q)
    if (afterCreate.size > 1) {
        const preferred = pickPreferredExplanationDoc(afterCreate.docs)
        const cleaned = await deleteSiblingExplanations(questionId, preferred.id)
        return { id: preferred.id, created: preferred.id === createdRef.id, cleaned }
    }

    return { id: createdRef.id, created: true, cleaned: 0 }
}